import { render, staticRenderFns } from "./QRPage.vue?vue&type=template&id=2f409da1&scoped=true"
import script from "./QRPage.vue?vue&type=script&lang=js"
export * from "./QRPage.vue?vue&type=script&lang=js"
import style0 from "./QRPage.vue?vue&type=style&index=0&id=2f409da1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f409da1",
  null
  
)

export default component.exports